// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","good":"ChildPhysical_good__CMly5","bad":"ChildPhysical_bad__Rjvot","dueVaccinationIcon":"ChildPhysical_dueVaccinationIcon__SQtKX"};